import React from 'react'

import { shape, string, arrayOf } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import moLogo from 'images/modelry_icon_rgb.svg'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import DropdownSection from './Components/DropdownSection/DropdownSection'

const earnLinks = (locale) => [
  {
    title: i18n.t('navigation.navbar.community.upload_3d_model', { ns: 'rails', lng: locale }),
    href: '/profile/upload/model',
    icon: 'upload',
    trackText: 'Upload 3D Model',
  },
  {
    title: i18n.t('navigation.navbar.community.search_for_projects', { ns: 'rails', lng: locale }),
    href: '/3d-modeling-jobs/browse',
    icon: 'project_search',
    trackText: 'Search for Projects',
  },
  {
    title: i18n.t('navigation.navbar.community.work_on_modelry', { ns: 'rails', lng: locale }),
    href: 'https://wildcat.cgtrader.com/',
    image: moLogo,
    trackText: 'Work on Modelry',
  },
]

const growYourSalesLinks = (locale) => [
  {
    title: i18n.t('navigation.navbar.grow_your_sales.sell_more', { ns: 'rails', lng: locale }),
    href: '/discover/sell-more',
    icon: 'trending_up',
    trackText: 'Sell More',
  },
  {
    title: i18n.t('navigation.navbar.grow_your_sales.3d_market_insights', { ns: 'rails', lng: locale }),
    href: '/discover/3d-market-trends',
    icon: 'bulb',
    trackText: 'Market Insights',
  },
  {
    title: i18n.t('navigation.navbar.grow_your_sales.top_model_searches', { ns: 'rails', lng: locale }),
    href: '/discover/3d-models-top-searches',
    icon: 'cube_search',
    trackText: 'Top Model Searches',
  },
  {
    title: i18n.t('navigation.navbar.grow_your_sales.top_print_searches', { ns: 'rails', lng: locale }),
    href: '/discover/3d-print-models-top-searches',
    icon: 'printer_search',
    trackText: 'Top Print Searches',
  },
]

function SellersHubDropdown({ id = undefined, communityLinks = EMPTY_ARRAY, locale = 'en' }) {
  const earnTitle = i18n.t('navigation.navbar.community.earn', { ns: 'rails', lng: locale })
  const growYourSalesTitle = i18n.t('navigation.navbar.grow_your_sales.title', { ns: 'rails', lng: locale })
  const communityTitle = i18n.t('navigation.navbar.community.title', { ns: 'rails', lng: locale })

  return (
    <div className="unified-nav__dropdown" id={id}>
      <DropdownSection heading={earnTitle} items={earnLinks(locale)} />
      <DropdownSection heading={growYourSalesTitle} items={growYourSalesLinks(locale)} divided />
      <DropdownSection heading={communityTitle} items={communityLinks} divided />
    </div>
  )
}

SellersHubDropdown.propTypes = {
  id: string,
  communityLinks: arrayOf(shape({
    href: string,
    trackText: string,
    title: string,
    icon: string,
  })),
  locale: string,
}

export default SellersHubDropdown
